import React from 'react';
import { FlexyTabs, TabStructure } from '@europrocurement/flexy-components';
import { CollectionInformationsTab } from '@europrocurement/l2d-modules';

const OrderBody: React.FunctionComponent = function () {
    const tabs: Array<TabStructure> = [
        {
            tabName: 'details',
            tabTitle: 'Détails de la commande',
            tabPanel: <CollectionInformationsTab source="BACK" />,
        },
    ];

    return (
        <FlexyTabs
            routerParameterName="order-detail"
            sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '15px' }}
            tabs={tabs}
            scrollbar={false}
            indicatorColor="primary"
        />
    );
};

export default OrderBody;
